import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../../crbt/crbtuicss';
import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';

export interface ArtistSearchListCSSStyle extends CRBTUICSSStyle
{
    getArtistSearchCSSStyle(): object;
    getTitleCSSStyle(): object;
    getPaginationCSSStyle(): object; 
}

export class ArtistSearchListCSSStyleImpl extends CRBTUICSSStyleImpl implements ArtistSearchListCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: '100%', 
            width: '100%',
            // display: "flex",
        };
    }

    getPaginationCSSStyle(): object 
    {
        return {
            height: "50px",
            width: "100%",
        };
    }

    getTitleCSSStyle(): object 
    {
        return {
            display: "flex",
            textAlign: "center",
            justifyContent: 'flex-start',
            height: "30px",
            fontWeight: 800,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "30px", 
        };
    } 

    getArtistSearchCSSStyle(): object 
    {
        return {
            height: '300px', 
            width: '100%',  
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/searchlist/artist/artistlistcss.tsx